<template>
  <div class="notice-detail" >
    <div class="global" >
      <div class="detail" >
        <div class="hd" >
          <h2>{{ resultNotice.title }}</h2>
          <div class="info" >
            <span>发布人：{{ resultNotice.makeUserName }}</span>
            <span>发布时间：{{ resultNotice.publicTime }}</span>
          </div>
        </div>
        <div class="bd" >
          <p v-html="resultNotice.content" ></p>
          <div class="pic" v-if="resultNotice.picPath != null">
            <img :src="resultNotice.picPath"/>
          </div>
          <div class="options" v-if="resultNotice.enclosure != null" >
            <span>附件</span>
            <div class="doc">
              <span><i class="iconfont icon-wenjianjia1" ></i></span>
              <em>{{ resultNotice.name }}</em>
              <em class="op-size" >{{ resultNotice.enclosureSize }}</em>
            </div>
          </div>
        </div>
      </div>
      <div class="unread"  v-if="isMakeUser"  >
        <router-link :to="{ name: 'TNoticeUnread', query: { id : id, userId : userId } }" class="flex flex-pack-justify" >
          <span>未阅读人数</span>
          <span>{{ unReadCount }}人></span>
        </router-link>     
      </div>
      <div class="msg" >
          <comment-content :first-comment= "noParentComments" :my-comment="pfNoticeComments" @change="answerCommenter"></comment-content>
      </div>
          <comment-textarea v-if="isEdit" :child-edit="isEdit" @submit="addComment" :name="oldComment"  ></comment-textarea>
    </div>
    <div class="bottom-wrapper" >
      <div class="nav-bottom flex flex-pack-around" v-if="isComment" >
        <i class="iconfont icon-back" @click="goBack" ></i>
        <router-link tag="i" class="iconfont icon-home" :to="{ name:'Home' }" ></router-link>
        <i class="iconfont icon-msg" @click="showComment" ></i>
      </div>
    </div>
  </div>

</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import { getUserInfo } from '@/service/user-service'
import default_pic from '@/assets/images/leaver.png'
// let comment_receive_uid = null; // 当前回复接收用户UID

Vue.component('commentContent',{
  template:`<div>
              <p v-if="len(myComment) == 0" >暂无评论,快来发表第一条评论吧!</p>
              <div v-else >
                <div class="title" >留言 {{firstComment.length}}</div>
                <ul class="msg-list" >
                  <li v-for="(item,index) in myComment" :key="item.id" :index="index" v-if="item.parentId == null ">
                    <img :src="item.headPic">
                    <div class="des" >
                      <div class="name" >{{ item.commentUserName }}</div>
                      <span class="time" >{{ item.pulicTime }}</span>
                      <div class="content">
                        <p @click="answerCommenter(item.commentUserName, index, item.id)" >{{ item.content }}</p>
                        <div class="reply" v-for="(val,index) in myComment" v-if="val.parentId == item.id">
                          <p class="reply-other">{{val.commentUserName}}<span>回复</span>{{val.parentName}}：<span>{{ val.content }}</span></p>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>`,
  props:['myComment','firstComment'],
  methods: {
    answerCommenter(name,index, parentId) {
      // console.log(parentId)
      this.$emit("change",name,index, parentId);
    },
    len(items) {
      return items && items.length;
    }
  }
});
Vue.component('commentTextarea',{
  template:`<div class="comment flex">
            <input type="text" v-model="commentText" class="flex-1" >
            <button @click="addComment" >发送</button>
          </div>`,
  props:['type','name','childEdit'],
  data() {
    return {
      commentText:''
    }
  },

  methods: {
    addComment() {
      // 添加公告评论
      this.$http.get('/api/mobile/notice/addNoticeComment',
        {
          params:
            {
              content: this.commentText,
              noticeId: this.$route.params.id,
              parentId: this.$parent.comment_receive_uid,
              userId: this.$route.query.userId
            }
        }
        ).then( res => {
          this.$emit("submit",res.data);
          this.commentText = "";
        });
    }
  }
});


export default {
  data() {
    return {
      comment_receive_uid: null,
      isMakeUser: true,   //是否为发布者,true为发布者
      resultNotice: {},   //公告详情
      unReadCount: 0,
      id: 0,
      isComment: true,     //是否显示底部tab 评论入口
      isEdit: false,      //是否显示评论输入框
      pfNoticeComments: [],    //所有评论内容
      oldComment: null,       //旧评论者的名字
      chosedIndex: -1,        //被选中的评论的index
      userId: this.$route.query.userId,
      noParentComments: []   //没有父元素的评论
    }
  },
  mounted() {
    this.$nextTick(() => {
      getUserInfo().then((user) => {
        this.current_user = user;
      })
      // 公告通知详情
      this.$http.get('/api/mobile/notice/getNoticeInfo',
        {params:
          {
            noticeId: this.$route.params.id,
            userId: this.userId
          }
        }
      ).then( res => {
        if(res.data.code == 0) {
          this.resultNotice = res.data.resultNotice;
          this.unReadCount = res.data.unReadCount;
          this.id = this.$route.params.id;
          this.pfNoticeComments = res.data.pfNoticeComments;
          this.pfNoticeComments = _.map(this.pfNoticeComments,(comment,index) => {
            comment.headPic = comment.headPic || default_pic;
            return comment;
          });
          this.noParentComments = _.filter(this.pfNoticeComments, comment => {
            return comment.parentId == null;
          });
          // console.log(this.noParentComments.length);
          this.isMakeUser = res.data.isMakeUser;

          //截取附件名
          if(this.resultNotice.enclosureName != null) {
            var name = this.resultNotice.enclosureName;
            var index = name.lastIndexOf("\/");  
            this.resultNotice.name = name.substring(index + 1, name.length);
            if(this.resultNotice.name.length > 20) {
              this.resultNotice.name = this.resultNotice.name.substring(0,20) + '...';
            }
          }
        } 
        // else if(res.data.code == 1) {
        //     alert('登录超时,请重新登录!');
        //     this.$router.replace({ name: 'Login' });
        // } else {
        //     alert('请求失败,请检查后台设置!');
        // }
      });
    });
  },
  methods: {
    showComment() {
      this.isComment = false;
      this.isEdit = true;
    },
    addComment: function(data) {
      data.pfNoticeComment.headPic = this.current_user.headPicUrl || default_pic;
      data.pfNoticeComment.commentUserName = this.current_user.userName;
      data.pfNoticeComment.parentName = this.oldComment;
      this.pfNoticeComments.push(data.pfNoticeComment);
      if(data.pfNoticeComment.parentId == null) {
        this.noParentComments.push(data.pfNoticeComment);
      }
      this.isComment = true;
      this.isEdit = false;
    },
    answerCommenter: function(name,index, parentId) {
      this.isComment = false;
      this.isEdit = true;
      this.oldComment = name;
			this.chosedIndex = index;
      this.comment_receive_uid = parentId;
    },
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/notice/notice-detail.vue